import { useState } from "react";
import { Dialog, DialogPanel, DialogTitle } from "@headlessui/react";
import { BookingWorkspace } from "./BookingWorkspacePage";

export default function BookingDetailsPanel({ bookingId, onClose, onOpenFullDetails, onChanged }) {
  const [busy, setBusy] = useState(false);
  return <Dialog open onClose={() => !busy && onClose()} className="fixed inset-0 z-50">
    <div className="fixed inset-0 bg-slate-950/10" aria-hidden="true"/>
    <div className="fixed inset-0 flex justify-end pl-16">
      <DialogPanel className="h-full w-[560px] max-w-full bg-white shadow-2xl">
        <DialogTitle className="sr-only">Booking details</DialogTitle>
        <BookingWorkspace bookingId={bookingId} panel onClose={onClose} onOpenFullDetails={onOpenFullDetails} onBusyChange={setBusy} onChanged={onChanged}/>
      </DialogPanel>
    </div>
  </Dialog>;
}
